import { render, staticRenderFns } from "./modal-order-details.vue?vue&type=template&id=0033be6a&scoped=true&"
import script from "./modal-order-details.vue?vue&type=script&lang=js&"
export * from "./modal-order-details.vue?vue&type=script&lang=js&"
import style0 from "./modal-order-details.vue?vue&type=style&index=0&id=0033be6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033be6a",
  null
  
)

export default component.exports